import React from 'react';
import { GROWINTEL_PATHS } from '../../constants/GrowintelPaths';
import { useRouter } from '../../hooks/useRouter';

type Props = {
  id: string;
  children: React.ReactNode;
  cursor?: 'pointer' | 'default';
  hoverUnderline?: boolean;
  className?: string;
};

export default function RestaurantLink({
  id,
  children,
  cursor = 'pointer',
  hoverUnderline = false,
  className = '',
}: Props) {
  const router = useRouter();
  return (
    <div
      className={`${className} ${cursor === 'pointer' ? 'cursor-pointer' : ' '} ${
        hoverUnderline ? 'hover:underline ' : ''
      }`}
      onClick={() => {
        router.push(GROWINTEL_PATHS.DETAIL.RESTAURANT.replace(':id', id));
      }}
    >
      {children}
    </div>
  );
}
